import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Card } from "../ui/card";
import { Loader2 } from "lucide-react";
import { PropostaAssinaturasCard } from "./PropostaAssinaturasCard";

const ELEGIVEIS = ["enviada", "assinada", "aprovada"];

export default function AssinaturasLead({ leadId }) {
  const [propostas, setPropostas] = useState(null);

  useEffect(() => {
    api.get("/proposta-nativa", { params: { lead_id: leadId } })
      .then(({ data }) => setPropostas((Array.isArray(data) ? data : data.items || []).filter((p) => ELEGIVEIS.includes(p.status))))
      .catch(() => setPropostas([]));
  }, [leadId]);

  if (!propostas) return <Loader2 className="animate-spin text-muted-foreground" size={18} />;
  if (!propostas.length) {
    return (
      <Card className="p-8 text-center text-sm text-muted-foreground" data-testid="assinaturas-lead-vazio">
        Nenhuma proposta enviada para este lead. As assinaturas ficam disponíveis após o envio da proposta
      </Card>
    );
  }
  return (
    <div className="space-y-4" data-testid="assinaturas-lead">
      {propostas.map((p) => <PropostaAssinaturasCard key={p.id} proposta={p} />)}
    </div>
  );
}
